const API_URL = 'https://backleaveout.youmingtechnologies.co.ke'; // Flask backend URL

// Auth Services
export const register = async (userData) => {
  try {
    const response = await fetch(`${API_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Registration failed');
    }
    return await response.json();
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

export const login = async (userData) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Login failed');
    }
    return await response.json();
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// 🔧 Fixed: OTP and Password Reset Services
export const requestOtp = async ({ email }) => {
  try {
    const response = await fetch(`${API_URL}/request_reset_password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to request OTP');
    }
    return await response.json();
  } catch (error) {
    console.error('Request OTP error:', error);
    throw error;
  }
};

export const verifyOtp = async ({ email, otp }) => {
  try {
    const response = await fetch(`${API_URL}/verify_otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, otp }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to verify OTP');
    }
    return await response.json();
  } catch (error) {
    console.error('Verify OTP error:', error);
    throw error;
  }
};

export const resetPassword = async ({ email, otp, new_password }) => {
  try {
    const response = await fetch(`${API_URL}/reset_password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, otp, new_password }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to reset password');
    }
    return await response.json();
  } catch (error) {
    console.error('Reset password error:', error);
    throw error;
  }
};

// Student Leave Services
export const getStudentLeaves = async (token, studentId = null) => {
  try {
    const url = studentId
      ? `${API_URL}/leaves?student_id=${studentId}`
      : `${API_URL}/leaves`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch student leaves');
    }
    return await response.json();
  } catch (error) {
    console.error('Get student leaves error:', error);
    throw error;
  }
};

// Leave Services
export const createLeave = async (token, leaveData) => {
  try {
    const response = await fetch(`${API_URL}/leaves`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(leaveData),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create leave');
    }
    return await response.json();
  } catch (error) {
    console.error('Create leave error:', error);
    throw error;
  }
};

export const deleteLeave = async (token, leaveId) => {
  try {
    const response = await fetch(`${API_URL}/leaves/${leaveId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to delete leave');
    }
    return await response.json();
  } catch (error) {
    console.error('Delete leave error:', error);
    throw error;
  }
};

export const getAllStudents = async (token) => {
  try {
    const response = await fetch(`${API_URL}/students`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch students');
    }

    return await response.json();
  } catch (error) {
    console.error('Get students error:', error);
    throw error;
  }
};

export const getLeaves = async (token) => {
  try {
    const response = await fetch(`${API_URL}/leaves`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch leaves');
    }
    return await response.json();
  } catch (error) {
    console.error('Get leaves error:', error);
    throw error;
  }
};

// Professor Services
export const getPendingLeaves = async (token) => {
  try {
    const response = await fetch(`${API_URL}/leaves/pending`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch pending leaves');
    }
    return await response.json();
  } catch (error) {
    console.error('Get pending leaves error:', error);
    throw error;
  }
};

export const approveLeave = async (token, leaveId, comments = '') => {
  try {
    const response = await fetch(`${API_URL}/leaves/${leaveId}/approve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ comments }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to approve leave');
    }
    return await response.json();
  } catch (error) {
    console.error('Approve leave error:', error);
    throw error;
  }
};

export const rejectLeave = async (token, leaveId, comments = '') => {
  try {
    const response = await fetch(`${API_URL}/leaves/${leaveId}/reject`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ comments }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to reject leave');
    }
    return await response.json();
  } catch (error) {
    console.error('Reject leave error:', error);
    throw error;
  }
};

// Document Services
export const uploadDocument = async (token, leaveId, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_URL}/leaves/${leaveId}/documents`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to upload document');
    }
    return await response.json();
  } catch (error) {
    console.error('Document upload error:', error);
    throw error;
  }
};

// Add the deleteStudent function
export const deleteStudent = async (token, studentId) => {
  try {
    const response = await fetch(`${API_URL}/students/${studentId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to delete student');
    }
    return await response.json();
  } catch (error) {
    console.error('Delete student error:', error);
    throw error;
  }
};
